import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M23.45 25.54c0-2.31-1.07-4-1.45-5.54h5a2.81 2.81 0 003-2.81 4 4 0 00-1-2.68 4.88 4.88 0 00-.47-4.35 4.57 4.57 0 00-.84-4.09 3.09 3.09 0 00-.32-2.45C26.34 2 23.74 2 21.55 2h-.14a14 14 0 00-6.11 1.73 7.9 7.9 0 01-2.69.89.63.63 0 00-.61.65V17a.7.7 0 00.18.46c2 2.14 2.9 4.41 4.56 6.19A6.86 6.86 0 0118 26.84c.23 1 .7 3.16 1.74 3.16 1.26 0 3.71-.44 3.71-4.46z"/><path d="M9 16V4a2 2 0 00-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h3a2 2 0 002-2zM6.51 5.5a1 1 0 11-1-1 1 1 0 011 1z"/>';
export var ThumbsDownSVG = function ThumbsDownSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ThumbsDownSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ThumbsDownSVG);